import { ROLES } from '@/constants/roles';

// export const associationsList = {
//   path: '/associations',
//   name: 'ui-associations-list',
//   component: () => import('./views/associations-list.vue'),
//   meta: {
//     layout: 'ui-design',
//     title: 'Ассоциации',
//     accessList: [ROLES.club],
//   },
// };

export default [
  {
    path: '/associations',
    name: 'associations',
    component: () => import('./views/event-associations.vue'),
    meta: {
      title: 'Ассоциации',
      layout: 'ui-design',
      icon: '$ifolder-favorite-outline',
    },
  },
  // {
  //   path: '/organizer-association/:id',
  //   name: 'organization-association',
  //   component: () => import('./views/event-association.vue'),
  //   meta: {
  //     title: 'Ассоциация',
  //     layout: 'ui-design',
  //     back: true,
  //     accessList: [ROLES.organization],
  //   },
  // },
  {
    path: '/association-dashboard/:id',
    name: 'association-dashboard',
    component: () => import('./views/association-dashboard/index.vue'),
    meta: {
      title: 'Моя ассоциация',
      layout: 'ui-design',
      icon: '$ui-association',
      accessList: [ROLES.organization],
    },
    redirect: (to) => ({
      name: 'association-dashboard-main',
      params: {
        id: to.params.id,
      },
    }),
    children: [
      {
        path: 'main',
        name: 'association-dashboard-main',
        component: () => import('./views/association-dashboard/main.vue'),
        meta: {
          title: 'Моя ассоциация',
          layout: 'ui-design',
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'plan',
        name: 'association-dashboard-plan',
        component: () => import('./views/association-dashboard/plan.vue'),
        meta: {
          layout: 'ui-design',
          title: 'План мероприятий ассоциации',
          accessList: [ROLES.organization],
          back: true,
        },
      },
      {
        path: 'events',
        name: 'association-dashboard-events',
        component: () => import('./views/association-dashboard/events.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Мероприятия',
          accessList: [ROLES.organization],
          back: true,
        },
      },
      {
        path: 'members',
        name: 'association-dashboard-members',
        component: () => import('./views/association-dashboard/members.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Члены ассоциации',
          accessList: [ROLES.organization],
          back: true,
        },
      },
      {
        path: 'organizers',
        name: 'association-dashboard-organizers',
        component: () => import('./views/association-dashboard/organizers.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Организаторы мероприятий',
          accessList: [ROLES.organization],
          back: true,
        },
      },
      {
        path: 'rating',
        name: 'association-dashboard-rating',
        component: () => import('./views/association-dashboard/rating.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Рейтинг',
          accessList: [ROLES.organization],
          back: true,
        },
      },
      {
        path: 'clubs',
        name: 'association-dashboard-clubs',
        component: () => import('./views/association-dashboard/clubs.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Клубы',
          accessList: [ROLES.organization],
          back: true,
        },
      },
      {
        path: 'offices',
        name: 'association-dashboard-offices',
        component: () => import('./views/association-dashboard/offices.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Представительства и отделения',
          accessList: [ROLES.organization],
          back: true,
        },
      },
    ],
  },
];
